import React from 'react'

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowLeftGray from "./../../../../assets/img/DashboardICons/ArrowLeftGray.svg";
import { Link } from 'react-router-dom';

const StaffManagmentRequestBoxs = () => {
    return (
        <div dir="rtl" className={`d-flex justify-content-between flex-wrap align-items-center mt-4 py-2 mx-4 px-2`}>
            <div className="w-100 d-flex justify-content-between align-items-center flex-wrap">
                <div className={`d-flex justify-content-between align-items-center ${styles.total_staff_financial_request_box}`}>
                    <h4 className={`mb-0 ${styles.title_staff_financial_request_box}`}> درخواست‌های تسویه مالی مشاوران </h4>
                    <Link to={{
                        pathname: `/staff-managment-financial-request-detail`,
                        state: "درخواست‌های تسویه مالی مشاوران"
                    }}>
                        <img src={arrowLeftGray} alt="arrow-left-gray" role="button" />
                    </Link>
                </div>
                <div className={`d-flex justify-content-between align-items-center ${styles.total_staff_financial_request_box}`}>
                    <h4 className={`mb-0 ${styles.title_staff_financial_request_box}`}> درخواست‌های مساعده </h4>
                    <Link to={{
                        pathname: `/staff-managment-financial-request-detail`,
                        state: "درخواست‌های مساعده"
                    }}>
                        <img src={arrowLeftGray} alt="arrow-left-gray" role="button" />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default StaffManagmentRequestBoxs;